import { render, staticRenderFns } from "./SessionFooterBtns.vue?vue&type=template&id=0a4e1efc"
import script from "./SessionFooterBtns.vue?vue&type=script&lang=js"
export * from "./SessionFooterBtns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports